import React,{useState, useEffect, useCallback} from 'react'
import { useSelector } from 'react-redux'
import Avatar from '../layout/Avatar';
import CompanyBubble from './CompanyBubble';
import { CompanylogoStorage_LINK } from '../../api/ApiUrl';

import { db } from '../../config/firebaseConfig';
import { onSnapshot, query, collection, doc, startAfter, limit, orderBy, getDocs } from "firebase/firestore";
import { auth } from '../../config/firebaseConfig';
import MsgBox from './MsgBox';
import { onAuthStateChanged } from 'firebase/auth';
import ActionMsg from './ActionMsg';
import { Close, SideBarShrink } from '../layout/Icons';
import UserBubbles from './UserBubbles';
import useSound from 'use-sound';
import tone from '../../msgTone.mp3'


const Messenger = ({showSidebar, setShowSidebar, setUnread}) => {
    const companies=useSelector((state)=>(state.company.value))
    const user=useSelector((state)=>(state.user.value))
    const [playTone]=useSound(tone, { volume: 0.25 });

    const [activeCompany,setActiveCompany]=useState({id:-1});
    
    const [roomUsers, setRoomUsers]=useState([]);
    const [showAllRoomUsers, setShowAllRoomUsers]=useState(false);

    const [messages, setMessages]=useState([]);
    const [lastKey, setLastKey]=useState()
    const [load, setLoad]=useState(false);
    const [EndData, setEndData]=useState(false);
    const [isEmptyMsg, setIsEmptyMsg]=useState(false);
    const [uid, setUid]=useState(null);
    const co=localStorage.getItem('activeCo')
    useEffect(()=>{
       const authChecker=onAuthStateChanged(auth, (user) => {
            if (user) {
             
              const uid = user.uid;
              setUid(uid)
            } else {
              setUid(null)
            }
          });
          return()=>{
            authChecker() 
          }
    },[])
    
   

    const setActive=useCallback((co)=>{
        if(!co?.id) return;
        localStorage.setItem('activeCo', co.id)
        setActiveCompany(co);
    },[])


    useEffect(()=>{
        if(companies.length>0){
            const savedCompany=co ? companies.find(c=>c.id==co) : null;
            setActive(savedCompany || companies[0])
        }

        return()=>{
            setActiveCompany({id:-1})
        }
    },[companies, co, setActive])



 
    useEffect(()=>{
            
            if(!activeCompany?.id || activeCompany.id<1){
              setMessages([]);
              setRoomUsers([]);
              setShowAllRoomUsers(false);
              setIsEmptyMsg(true);
              return;
            }

            setLoad(true);
            const q=query(collection(doc(db, 'Rooms', `${activeCompany.id}`), 'messages'), orderBy('createdAt','desc'), limit(30));

            const roomUserRef=query(collection(doc(db, 'Rooms', `${activeCompany.id}`), 'users'), limit(30));

            const listenMessages=onSnapshot(q, (snapShot)=>{
               
                        if(snapShot.size>0 && activeCompany.id>0){
                            const data=snapShot.docs.map(doc=>{return {...doc.data(), id: doc.id} })
                            setMessages(data);
                            const last=snapShot.docs[snapShot.docs.length-1]
                            setLastKey(last)
                            var unreadData=data.filter(d=>d.msgType==0).map(m=>({
                                ...m,
                                read:(Array.isArray(m.read) ? m.read : []).filter(r=>r==user.id)
                            }))
                            unreadData=unreadData.filter((d)=>{return d.read.length==0})
                            setUnread(unreadData.length);
                           
                            const check=data[0];
                            shouldPlaySound(check)
                            
                            setLoad(false)
                            setIsEmptyMsg(false)
                            setEndData(false)
                        }else{
                            setIsEmptyMsg(true)
                            setMessages([])
                            setLoad(false)
                        }
                    })

             const listenRoomUsers=onSnapshot(roomUserRef, (snapShot)=>{
                if(snapShot.size>0 && activeCompany.id>0){
                    const data=snapShot.docs.map(doc=>{return {...doc.data(), id: doc.id} })
                    setRoomUsers(data);
                }
             })       
    
        return ()=>{
            listenMessages()
            listenRoomUsers()
            setMessages([])
        } 
    },[activeCompany, user.id])


    const shouldPlaySound=(check)=>{
        if(check && check.msgType!=1){
            var read=check.read;
            if(!read.filter(r=>r==user.id).length>0){
                playTone()

            }
        }
    }

    const loadmoreMsg=(snapShot)=>{
        const noData=snapShot.size===0;
        if(!noData){
            const data=snapShot.docs.map(doc=>{return {...doc.data(), id: doc.id} })
            const last=snapShot.docs[snapShot.docs.length-1]
            setMessages((messages)=>[...messages, ...data]);
            setLastKey(last)
            setEndData(false)
        }else{
            setEndData(true)

        }
        setLoad(false);
    }

    const fetchMoreMsg=async()=>{
       if(!lastKey || load || EndData) return;
       const q=query(collection(doc(db, 'Rooms', `${activeCompany.id}`), 'messages'), orderBy('createdAt', 'desc'), startAfter(lastKey), limit(30))
        setLoad(true);
        const loadedMsg= await getDocs(q); 
        loadmoreMsg(loadedMsg)
    }

  return (
    <div className='messenger-shell'>
        
        {/* <button onClick={()=>{playTone()}}>check</button> */}

        {companies.length>1?
        <div className='messenger-company-strip no-scrollbar'>
        {companies.map((co)=>(
            <CompanyBubble 
            key={co.id} 
            co={co} 
            active={activeCompany.id} 
            setActive={setActive}/>
            )
            )}

            <button className='block ml-auto transition-all duration-150 ease-in-out 2xl:hidden text-slate-600 dark:text-slate-400 hover:text-orange-500 dark:hover:text-orange-600' 
                onClick={()=>setShowSidebar(!showSidebar)}>
                <SideBarShrink iconClass={'w-6 h-6'}/>
            </button>
        </div>
        :
        null
        }
        
        {activeCompany.id>0 &&
        <div className='messenger-panel'>
        
            <div className='messenger-header' >
            
            <div className='flex items-center justify-between gap-3'>


            <div className='flex items-center justify-start gap-2'>
                {activeCompany.logo?
                    <img src={`${CompanylogoStorage_LINK}${activeCompany.logo}`} className='object-cover w-10 h-10 rounded-lg'/>
                    :
                    <Avatar value={activeCompany.name} width='9' height='9' color={'bg-blue-500 text-white'}/>   
                    
                }
                <div>
                    <p className='text-[11px] font-bold uppercase tracking-wide text-slate-500 dark:text-slate-600'>Messages</p>
                    <h4 className='text-sm font-bold text-slate-700 dark:text-slate-100'>{activeCompany.name}</h4>
                    <p className='text-[11px] font-semibold text-slate-400 dark:text-slate-600'>{roomUsers.length} people online room</p>
                </div>
            </div> 

            <button
                type='button'
                className='messenger-mobile-close'
                onClick={()=>setShowSidebar(false)}
                title='Close messages'
            >
                <Close iconClass={'w-4 h-4'}/>
            </button>
            
                </div>
             </div>

             {roomUsers.length>0 &&
                <div className={`messenger-users-strip ${showAllRoomUsers ? 'expanded' : ''}`}>
                    {(showAllRoomUsers ? roomUsers : roomUsers.slice(0, 5)).map((user,i)=>(
                        <UserBubbles key={user.id || `${user.uid || user.userName}-${i}`} user={user}/>
                    ))}
                    {roomUsers.length > 5 &&
                    <button
                        type='button'
                        className={`messenger-users-more ${showAllRoomUsers ? 'active' : ''}`}
                        onClick={()=>setShowAllRoomUsers(!showAllRoomUsers)}
                        title={showAllRoomUsers ? 'Show fewer people' : `Show ${roomUsers.length - 5} more people`}
                    >
                        {showAllRoomUsers ? 'Less' : `+${roomUsers.length - 5}`}
                    </button>
                    }
                </div>
            }


        <MsgBox
        messages={messages} 
        uid={uid} 
        fetchMoreMsg={fetchMoreMsg}
        load={load}
        setLoad={setLoad}
        EndData={EndData}
        isEmptyMsg={isEmptyMsg}
        roomId={activeCompany.id}
        compLength={companies.length}
        />
        
        </div>
        }
         {activeCompany.id>0 &&
        <ActionMsg roomId={activeCompany.id}/>
         }

    </div>
  )

}

export default Messenger
